import { PieSectorDataItem } from 'recharts'

type GaugeNeedleProps = PieSectorDataItem & {
  currentName: string
}

const GaugeNeedle = ({ cx, cy, midAngle, innerRadius, outerRadius, name, currentName }: GaugeNeedleProps) => {
  if (name !== currentName) {
    return null
  }

  const needleBaseCenterX = cx
  const needleBaseCenterY = cy - cy * 0.1
  const needleLength = innerRadius - (outerRadius - innerRadius) / 2
  const needleWidth = cy * 0.05

  return (
    <g>
      <path
        d={`M${needleBaseCenterX - needleWidth / 2},${needleBaseCenterY}L${needleBaseCenterX + needleWidth / 2},${needleBaseCenterY}L${needleBaseCenterX},${needleBaseCenterY - needleLength}Z`}
        className="mg-gauge-needle"
        style={{
          transform: `rotate(${90 - midAngle}deg)`,
          transformOrigin: `${needleBaseCenterX}px ${needleBaseCenterY}px`
        }}
      />
      <circle cx={needleBaseCenterX} cy={needleBaseCenterY} className="mg-gauge-needle-circle" />
    </g>
  )
}

export default GaugeNeedle
